const TEMPLATE_BASE_URL = new URL('../../templates/', import.meta.url);

const FALLBACK_OPTIONS = [
  { id: 'counter', label: 'Simple Counter' }
];

let templateOptionsPromise = null;
const templatePromises = new Map();

function templateUrl(file) {
  return new URL(file, TEMPLATE_BASE_URL).toString();
}

function normalizeId(value) {
  const id = String(value || '').trim();
  return /^[a-z0-9-]+$/.test(id) ? id : '';
}

async function fetchJson(url, label) {
  const response = await fetch(url, { headers: { accept: 'application/json' } });
  if (!response.ok) {
    throw new Error(`${label} request failed with ${response.status}`);
  }
  return response.json();
}

function normalizeOptions(value) {
  if (!Array.isArray(value)) return FALLBACK_OPTIONS;
  const options = value
    .map((item) => ({
      id: normalizeId(item?.id),
      label: String(item?.label || item?.id || '').trim()
    }))
    .filter((item) => item.id && item.label);
  return options.length ? options : FALLBACK_OPTIONS;
}

function normalizeTemplate(value, requestedId) {
  if (!value || typeof value !== 'object') return null;
  const id = normalizeId(value.id) || requestedId;
  if (id !== requestedId) return null;
  return {
    id,
    label: String(value.label || id),
    html: String(value.html || ''),
    css: String(value.css || ''),
    js: String(value.js || '')
  };
}

export async function getTemplateOptions() {
  if (!templateOptionsPromise) {
    templateOptionsPromise = fetchJson(templateUrl('manifest.json'), 'Template manifest')
      .then(normalizeOptions)
      .catch((err) => {
        console.error('Failed to load template manifest:', err);
        return FALLBACK_OPTIONS;
      });
  }
  return templateOptionsPromise;
}

export async function getTemplate(name) {
  if (name === 'empty') {
    return { id: 'empty', label: 'Blank Playground', html: '', css: '', js: '' };
  }

  const id = normalizeId(name);
  if (!id) return null;

  if (!templatePromises.has(id)) {
    templatePromises.set(id, fetchJson(templateUrl(`${id}.json`), `Template ${id}`)
      .then((payload) => normalizeTemplate(payload, id))
      .catch((err) => {
        templatePromises.delete(id);
        console.error(`Failed to load template '${id}':`, err);
        return null;
      }));
  }

  return templatePromises.get(id);
}
